import React from 'react'

import style from './style.module.css'

function Notification({ children }: React.ComponentPropsWithRef<'div'>) {
  return (
    <div className={style.wrapper}>
      <div className={style.notification}>{children}</div>
    </div>
  )
}

export default Notification
